(() => {
  const oneTimeDeal = source => {
    const deal = JSON.parse(JSON.stringify(source));
    const first = deal.dealBars?.find(bar => bar.dealBarType === 'quantity-break' && bar.quantity === 1);
    if (!first) throw new Error('Einzelflasche fehlt');
    deal.preselectedDealBarId = first.id;
    deal.subscriptionsEnabled = false;
    delete deal.subscriptions;
    for (const bar of deal.dealBars) {
      bar.sellingPlanEnabled = false;
      delete bar.sellingPlanGid;
    }
    return deal;
  };
  const oneTimeProduct = source => {
    if (source.requiresSellingPlan) throw new Error('Einmalkauf nicht verfügbar');
    return { ...source, sellingPlans: [], variants: source.variants.map(variant => ({ ...variant, sellingPlans: [] })) };
  };
  const validItems = items => {
    if (!Array.isArray(items) || !items.length) return false;
    try {
      return items.every(item => item.id && Number.isInteger(item.quantity) && item.quantity > 0 && !item.selling_plan &&
        !JSON.parse(item.properties?.__kaching_bundles || '{}').sellingPlan);
    } catch (_) { return false; }
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = { oneTimeDeal, oneTimeProduct, validItems }; return; }
  const root = document.querySelector('[data-product-one-time]');
  if (!root) return;
  const form = root.querySelector('form[data-natunora-offer-form]');
  const button = form.querySelector('[data-main-buy]');
  const error = root.querySelector('[data-one-time-error]');
  const fail = () => {
    error.hidden = false;
    error.textContent = 'Das Angebot konnte nicht geladen werden. Bitte lade die Seite erneut.';
  };
  const ready = () => {
    const block = form.querySelector('kaching-bundles-block');
    try { return block?.validateItemSelection().valid && validItems(block.items()); }
    catch (_) { return false; }
  };
  const unlock = () => {
    if (!button.hasAttribute('data-one-time-pending') || !ready()) return;
    button.removeAttribute('data-one-time-pending');
    button.disabled = button.dataset.productAvailable !== 'true';
    error.hidden = true;
  };
  for (const type of ['click', 'submit']) window.addEventListener(type, event => {
    const targetForm = type === 'submit' ? event.target : event.target.closest('[name="add"]')?.form;
    if (targetForm !== form) return;
    if (ready()) { error.hidden = true; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    fail();
  }, { capture: true });
  form.addEventListener('kaching-bundles-block-loaded', unlock);
  form.addEventListener('items-changed', unlock);
  window.addEventListener('kaching-bundles-initialized', unlock);
  try {
    const configNode = document.querySelector('#kaching-bundles-config');
    const dealNodes = [...document.querySelectorAll('script.kaching-bundles-deal-block-settings')];
    const productNodes = [...document.querySelectorAll('script.kaching-bundles-product[data-main]')];
    if (!configNode || !dealNodes.length || !productNodes.length || typeof window.kachingBundlesInitialize !== 'function') throw new Error('Konfiguration fehlt');
    const deals = dealNodes.map(node => oneTimeDeal(JSON.parse(node.textContent)));
    const products = productNodes.map(node => oneTimeProduct(JSON.parse(node.textContent)));
    dealNodes.forEach((node, index) => { node.textContent = JSON.stringify(deals[index]); });
    productNodes.forEach((node, index) => { node.textContent = JSON.stringify(products[index]); });
    const config = JSON.parse(configNode.textContent);
    config.includeSellingPlans = false;
    configNode.textContent = JSON.stringify(config);
    window.kachingBundlesInitialize();
  } catch (_) { fail(); }
})();
